/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathEqualLower = createReactComponent("outline", "math-equal-lower", "IconMathEqualLower", [["path", { "d": "M19 18l-14 -4", "key": "svg-0" }], ["path", { "d": "M19 14l-14 -4l14 -4", "key": "svg-1" }]]);

export { IconMathEqualLower as default };
//# sourceMappingURL=IconMathEqualLower.mjs.map
